import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import PageContent from "~/client/components/PageContent";
import PageHeading from "~/client/components/PageHeading";
import { Paragraph } from "./styled";
const HomePage = () => {
    const analytics = useAnalytics();
    useEffect(() => {
        analytics.page({ title: "Home" });
    }, [analytics]);
    return (_jsxs(PageContent, { "data-testid": "home-page", children: [_jsx(PageHeading, { children: "Home" }), _jsxs("div", { children: [_jsx(Paragraph, { children: "Welcome to Tiny Recipe Box!" }), _jsx(Paragraph, { children: "This site and accompanying browser extension are still in development and will be coming soon." })] })] }));
};
export default HomePage;
